<template>
  <div class="costos-por-etapa mt-3">
    <!-- Título + Toggle -->
    <div class="d-flex justify-content-between align-items-center">
      <h6 class="mb-0 text-primary">
        <font-awesome-icon icon="chart-pie" class="me-2" />
        Costos por Etapa
      </h6>
      <button class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-2" @click="colapsado = !colapsado">
        <font-awesome-icon :icon="colapsado ? 'chevron-down' : 'chevron-up'" />
        <span class="d-none d-sm-inline">{{ colapsado ? 'Ver Detalles' : 'Ocultar' }}</span>
      </button>
    </div>

    <!-- Resumen compacto visible aunque esté colapsado -->
    <div v-if="colapsado" class="text-muted mt-2 small">
      <em>Etapa más costosa:</em> <strong>{{ estadisticas.etapaMasCostosa || '—' }}</strong> • 
      <em>Total:</em> <strong>{{ estadisticas.totalCostos }} $</strong>
    </div>

    <!-- Contenido Expandible -->
    <transition name="fade">
      <div v-if="!colapsado" class="mt-3">
        <div class="d-flex flex-wrap gap-2">
          <span 
            v-for="(costo, etapa) in costosOrdenados" 
            :key="etapa" 
            class="badge chip p-2 d-flex align-items-center text-nowrap">
            <font-awesome-icon icon="leaf" class="me-1" />
            <strong>{{ etapa }}:</strong>&nbsp;{{ costo }} $
          </span>
        </div>

        <div class="stats mt-3 small">
          <p><strong>Etapa más costosa:</strong> {{ estadisticas.etapaMasCostosa }}</p>
          <p><strong>Total tareas:</strong> {{ estadisticas.totalTareas }}</p>
          <p><strong>Costo total:</strong> {{ estadisticas.totalCostos }} $</p>
          <p><strong>Promedio por etapa:</strong> {{ estadisticas.promedioCostoEtapa }} $</p>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
export default {
  props: {
    costos: {
      type: Object,
      default: () => ({}), // Valor predeterminado como objeto vacío
    },
    estadisticas: {
      type: Object,
      required: true, // Este sigue siendo obligatorio si depende de lógica
    },
  },
  data() {
    return {
      colapsado: true,
    };
  },
  computed: {
    costosOrdenados() {
      if (Object.keys(this.costos).length === 0) {
        return {}; // Si está vacío retorna sin errores.
      }
      return Object.entries(this.costos)
        .sort(([, costoA], [, costoB]) => costoB - costoA)
        .reduce((obj, [etapa, costo]) => {
          obj[etapa] = costo;
          return obj;
        }, {});
    },
  },
};
</script>


<style scoped>
.costos-por-etapa {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  font-size: 0.95rem;
}

.badge.chip {
  font-size: 0.85rem;
  font-weight: 500;
  background-color: #0d6efd;
  color: #fff;
  border-radius: 20px;
  padding-inline: 1rem;
  box-shadow: 0 0 8px rgba(13, 110, 253, 0.3);
  white-space: nowrap;
}

.badge.chip:hover {
  box-shadow: 0 0 12px rgba(13, 110, 253, 0.5);
}

.stats p {
  margin: 0.25rem 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

</style>
